type ResetCallback = () => void;

const registeredResets = new Set<ResetCallback>();

export const registerGlobalStoreReset = (reset: ResetCallback) => {
  registeredResets.add(reset);
  return () => registeredResets.delete(reset);
};

export const runRegisteredStoreResets = () => {
  registeredResets.forEach((reset) => reset());
};
